export default __webpack_public_path__ + "static/media/anniversarymob3.2de4a92b.webp";